export default __webpack_public_path__ + "static/media/proj6.5b1228b4.png";